import React, { useState } from 'react';
import { toast } from 'react-toastify';
import EmployeeProcessService from '../services/EmployeeProcessService';
import showToast from "../Utils/ToastContainer";
import * as XLSX from 'xlsx';
import { useLoading } from '../Utils/LoadingContext';
function InActiveUpload() {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const { setLoading } = useLoading();
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const downloadExcel = (data, fileName = "UploadErrors.xlsx") => {
    if (!data || data.length === 0) {
      console.warn("No data to export.");
      return;
    }
    else { alert('Excel upload processed successfully.Please check the output Excel for remarks/messages.'); }
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Errors");

    XLSX.writeFile(workbook, fileName); // triggers browser download
  };

  const handleUpload = async (e) => {
    e.preventDefault();

    if (!file) {
      toast.error("Please select a file to upload.");
      return;
    }
    setLoading(true);
    const formData = new FormData();
    formData.append("file", file);
    const message = "";
    try {
      setUploading(true);

      const response = await EmployeeProcessService.setInActiveUpload(formData);
      debugger;
      if (response.success && response.data.statusCode === 200) {
        const result = response?.data?.result || [];
        downloadExcel(result, "UploadErrors.xlsx");
        setLoading(false);
      }
      // When API returns any handled error (statusCode 400, 500, etc.)
      else if (response.data && response.data.message) {
        alert(response.data.message);
      }
      // When API response is empty or unexpected
      else {
        alert("Unexpected response from server.");
      }

    } catch (error) {
      // When axios throws (e.g., server down or unhandled error)
      console.error("Upload failed:", error);

      if (error.response && error.response.data && error.response.data.message) {
        // API threw an exception with structured response
        alert(error.response.data.message);
      } else {
        // Generic error
        alert("Upload failed due to server error.");
      }

      toast.error("Upload failed due to server error.");
    } finally {
      setUploading(false);
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleUpload} className="upload-form">
      <div className="row">
        <div className="col-12 mb-3 border-bottom pb-2">
          <h4 className="text-left text-primary">Employee Punch Bulk Upload</h4>
          <button
            type="button"
            onClick={async () => {
              const success = await EmployeeProcessService.getTemplate("InActiveUpload.xlsx");
              if (success) {
                showToast("Template downloaded successfully.", "success");
              }
            }}
            className="btn btn-outline-success"
          >
            Download InActive Employee Template
          </button>
        </div>

        <div className="form-group col-md-6">
          <input type="file" onChange={handleFileChange} />
        </div>

        <div className="form-group col-md-2">
          <button type="submit" disabled={uploading}>
            {uploading ? "Uploading..." : "Upload"}
          </button>
        </div>
      </div>
    </form>
  );
}

export default InActiveUpload;
